export default () => ({
  tiposDocumento: [],
  /** Evita repetir GET en cada montaje si ya hubo un intento */
  hasFetched: false,
  loadError: null,
  localidadesTaxonomia: [],
  barriosTaxonomia: [],
  geoTaxLoaded: false,
  geoTaxLoadError: null,
})
